// extracted by mini-css-extract-plugin
export default {"warning":"_9UB73"};